import React from 'react'
import Title from '../Components/Elements/Title';
import Text from '../Components/Elements/Text';
import MainContainer from '../Components/Elements/MainContainer';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

interface Props {
    useHelm?: boolean;
}

const Gifting = ({ useHelm } : Props) => {
    return (
        <MainContainer>
            {
                useHelm && (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>H&R Wedding | Gifting</title>
                    </Helmet>
                )
            }
            <Title size="3">Gifting</Title>
            <Text>Your presence at our wedding is the greatest gift we could ask for. </Text>
            <Text>But if you would like to contribute to our special day, we have created a honeymoon fund instead of registering for traditional gifts.</Text>
            <Text>To contribute, please click the link below to take you to our PayPal.me:</Text>
            <form action="https://www.paypal.com/paypalme/ryanholliewedding" method="get" target="_blank" className='flex justify-center'>
                <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded my-6 sm:w-1/4 font-lora">
                    Contribute to Our Honeymoon
                </button>
            </form>
            { useHelm && <Text>
                <Link
                    to="/app"
                    className="bg-blue-500 hover:bg-blue-700 font font-lora text-white font-bold py-2 px-4 rounded my-2 inline-block text-center"
                >
                    Back to home
                </Link>
            </Text>}
        </MainContainer>
    )

}

export default Gifting;